import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
const BreadCrumb = (props) => {
  return (
    <Breadcrumb className="container p-0">
      <Breadcrumb.Item  href={"/"}>
        {props.firstParent}
      </Breadcrumb.Item>

      <Breadcrumb.Item  active href={props.secondlink}>
        {props.secondParent}
      </Breadcrumb.Item>
      {props.thirdParent ? (
        <Breadcrumb.Item active href={props.thirdLink}>
          {props.thirdParent}
        </Breadcrumb.Item>
      ) : null}
    </Breadcrumb>
  );
};

export default BreadCrumb;
